import React from "react";
import { Link } from "react-router-dom";

export default function SingleRoomCard(props) {
  const confirmDeletingRoom = () => {
    const confirmation = window.confirm("Are you sure you want to delete it?");
    if (confirmation === true) {
      props.deleteHandler(props.roomId);
    } else {
      return;
    }
  };

  return (
    <div className="col-12 single-room-card mb-4">
      {/* Images */}
      <div className="images-cover d-flex justify-content-center align-items-center gap-4">
        <img src={props.img1} alt="Room-Img" />
        <img src={props.img2} alt="Room-Img" />
        <img src={props.img3} alt="Room-Img" />
      </div>

      {/* Room Name */}
      <h3 className="text-center room-name text-capitalize">
        {props.roomDetails.roomName}
      </h3>
      <div className="col-md-8 col-sm-10 d-block mx-auto p-0">
        <p className="room-card-description text-capitalize">
          {props.roomDetails.roomDescription}
        </p>
      </div>

      {/* Room Details and Amenities Start */}
      <div className="col-12 room-details-amenities main-card-cover d-flex flex-md-wrap flex-wrap gap-md-5 gap-4 justify-content-center align-items-start">
        {/* Room Details Start */}
        <div className="col-md-auto col-12 p-0 pe-5 ms-5 room-details">
          <h5 className="mb-3">Room Details</h5>
          <p className="mb-2">
            <span className="details-title">Hotel Name:&nbsp;&nbsp;</span>
            <span className="text-capitalize">
              {props.roomDetails.hotelName}
            </span>
          </p>
          <p className="mb-2">
            <span className="details-title">City Name:&nbsp;&nbsp;</span>
            <span className="text-capitalize">
              {props.roomDetails.roomCity}
            </span>
          </p>
          <p className="mb-2">
            <span className="details-title">Room No:&nbsp;&nbsp;</span>
            <span className="text-capitalize">{props.roomDetails.roomNo}</span>
          </p>
          <p className="mb-2">
            <span className="details-title">Beds:&nbsp;&nbsp;</span>
            <span className="text-capitalize">
              {props.roomDetails.roomBeds}
            </span>
          </p>
          <p className="mb-2">
            <span className="details-title">Room Area:&nbsp;&nbsp;</span>
            <span className="text-capitalize">
              {props.roomDetails.roomArea}
            </span>
          </p>
          <p className="mb-2">
            <span className="details-title">Room Max People:&nbsp;&nbsp;</span>
            <span className="text-capitalize">
              {props.roomDetails.roomMaxPeople}
            </span>
          </p>
          <p className="mb-2">
            <span className="details-title">Price Per Day:&nbsp;&nbsp;</span>
            <span className="text-capitalize">
              ${props.roomDetails.roomPrice}
            </span>
          </p>
        </div>
        {/* Room Details End */}

        {/* Room Amenities Start */}
        <div className="col-md-auto col-12 p-0 room-amenities">
          <h5 className="mb-3">Room Amenities</h5>
          <div className="col-12 d-flex gap-md-5 gap-3 p-0 room-amenities-main-cover">
            {/* Side 1 Start*/}
            <div className="col-6 p-0 room-amenities-side">
              <p className="mb-2">
                <i className="fa-solid fa-square-check me-2"></i>
                <span className="text-capitalize">
                  {props.roomAmenities.ra_one}
                </span>
              </p>
              <p className="mb-2">
                <i className="fa-solid fa-square-check me-2"></i>
                <span className="text-capitalize">
                  {props.roomAmenities.ra_two}
                </span>
              </p>
              <p className="mb-2">
                <i className="fa-solid fa-square-check me-2"></i>
                <span className="text-capitalize">
                  {props.roomAmenities.ra_three}
                </span>
              </p>
              <p className="mb-2">
                <i className="fa-solid fa-square-check me-2"></i>
                <span className="text-capitalize">
                  {props.roomAmenities.ra_four}
                </span>
              </p>
            </div>
            {/* Side 1 End*/}

            {/* Side 2 Start*/}
            <div className="col-6 p-0 room-amenities-side">
              <p className="mb-2">
                <i className="fa-solid fa-square-check me-2"></i>
                <span className="text-capitalize">
                  {props.roomAmenities.ra_five}
                </span>
              </p>
              <p className="mb-2">
                <i className="fa-solid fa-square-check me-2"></i>
                <span className="text-capitalize">
                  {props.roomAmenities.ra_six}
                </span>
              </p>
              <p className="mb-2">
                <i className="fa-solid fa-square-check me-2"></i>
                <span className="text-capitalize">
                  {props.roomAmenities.ra_seven}
                </span>
              </p>
              <p className="mb-2">
                <i className="fa-solid fa-square-check me-2"></i>
                <span className="text-capitalize">
                  {props.roomAmenities.ra_eight}
                </span>
              </p>
            </div>
            {/* Side 2 End*/}
          </div>
        </div>
        {/* Room Amenities End */}

        {/* Update and Delete Button */}
        <div className="update-delete-btns">
          <Link
            to={`/admin/edit-room/${props.roomId}`}
            className="update-btn btn"
          >
            <i className="fa-solid fa-pen"></i>
          </Link>
          <button className="del-btn btn" onClick={confirmDeletingRoom}>
            <i className="fa-solid fa-trash"></i>
          </button>
        </div>
      </div>
      {/* Room Details and Amenities End */}
    </div>
  );
}
